export default {
  ready: (state, getters, rootState, rootGetters) => {
    if (rootState.route.meta.ready) return true

    switch (rootState.route.name) {
      case 'Track':
        const track = rootGetters['v4/track/current']
        return (Object.keys(track).length > 0)
      case 'Language':
        return rootState.v4.language.selected
      case 'Location':
        return rootState.v4.location.selectionMade;
      case 'Triage':
        return rootGetters['v4/mrx/valid']
      case 'StreamlinedOption':
        return rootGetters['v4/track/selectedStreamlinedOptions'].length > 0
      case 'Panel':
        const currentPanel = rootGetters['v4/panel/current']
        return currentPanel.responses?.some(response => response.selected)
      case 'Preference':
        const currentPreference = rootGetters['v4/preference/current']
        return currentPreference.responses.some(response => response.selected)
      default:
        return false
    }
  },

  showPrevious: (state, getters, rootState, rootGetters) => {
    let showPrevious = true

    switch(rootState.route.name) {
      case 'Panel':
        const editMode = rootGetters['v4/track/editResponsesMode']
        showPrevious = !editMode
        break;
      case 'Location':
        showPrevious = false
        break;
    }

    return showPrevious
  },
}
